declare namespace $ {

	type $mol_select__hint_shm_projects_release_notes_view_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_shm_projects_release_notes_view_2 = $mol_type_enforce<
		ReturnType< $shm_projects_release_notes_view['audience'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_projects_release_notes_view_3 = $mol_type_enforce<
		({ 
			'technical': string,
			'product': string,
			'executive': string,
			'user': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_text__text_shm_projects_release_notes_view_4 = $mol_type_enforce<
		ReturnType< $shm_projects_release_notes_view['scope_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_projects_release_notes_view_5 = $mol_type_enforce<
		ReturnType< $shm_projects_release_notes_view['content_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_projects_release_notes_view extends $mol_view {
		audience( next?: string ): string
		Audience( ): $mol_select
		scope_text( ): string
		Scope( ): $mol_text
		content_text( ): string
		Content( ): $mol_text
		notes( ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map